__turbopack_context__.v({
  "activePage": "Blog-module__qgnGkG__activePage",
  "author": "Blog-module__qgnGkG__author",
  "authorName": "Blog-module__qgnGkG__authorName",
  "avatar": "Blog-module__qgnGkG__avatar",
  "avatarWrapper": "Blog-module__qgnGkG__avatarWrapper",
  "blogSection": "Blog-module__qgnGkG__blogSection",
  "card": "Blog-module__qgnGkG__card",
  "cardTitle": "Blog-module__qgnGkG__cardTitle",
  "categoryBadge": "Blog-module__qgnGkG__categoryBadge",
  "container": "Blog-module__qgnGkG__container",
  "content": "Blog-module__qgnGkG__content",
  "date": "Blog-module__qgnGkG__date",
  "excerpt": "Blog-module__qgnGkG__excerpt",
  "footer": "Blog-module__qgnGkG__footer",
  "grid": "Blog-module__qgnGkG__grid",
  "header": "Blog-module__qgnGkG__header",
  "image": "Blog-module__qgnGkG__image",
  "imageWrapper": "Blog-module__qgnGkG__imageWrapper",
  "loadingContainer": "Blog-module__qgnGkG__loadingContainer",
  "loadingText": "Blog-module__qgnGkG__loadingText",
  "pageButton": "Blog-module__qgnGkG__pageButton",
  "pageNumber": "Blog-module__qgnGkG__pageNumber",
  "pageNumbers": "Blog-module__qgnGkG__pageNumbers",
  "pagination": "Blog-module__qgnGkG__pagination",
  "readMore": "Blog-module__qgnGkG__readMore",
  "readTime": "Blog-module__qgnGkG__readTime",
  "spin": "Blog-module__qgnGkG__spin",
  "spinner": "Blog-module__qgnGkG__spinner",
  "subtitle": "Blog-module__qgnGkG__subtitle",
  "title": "Blog-module__qgnGkG__title",
});
